var React = require('react');

function PersonAvatarInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"56","height":"56","rx":"8","fill":"#EAF3FF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28 27.25C30.8995 27.25 33.25 24.8995 33.25 22C33.25 19.1005 30.8995 16.75 28 16.75C25.1005 16.75 22.75 19.1005 22.75 22C22.75 24.8995 25.1005 27.25 28 27.25Z","stroke":"#6297FF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18.25 39.25C18.25 33.8652 22.6152 29.5 28 29.5C33.3848 29.5 37.75 33.8652 37.75 39.25","stroke":"#6297FF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

PersonAvatarInline.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = PersonAvatarInline;

PersonAvatarInline.default = PersonAvatarInline;
